module.exports = __webpack_public_path__ + "static/media/image24.352bda67.JPG";